import { render, staticRenderFns } from "./CongregationForm.vue?vue&type=template&id=80b35ba6&scoped=true"
import script from "./CongregationForm.vue?vue&type=script&lang=js"
export * from "./CongregationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b35ba6",
  null
  
)

export default component.exports